import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./styles.scss";
import sanitizeHtml from "sanitize-html";
import { Parser } from "html-to-react";
import CountdownTimer from "../CountDownTime";
import { useGlobalAudioPlayer } from "react-use-audio-player";
import ButtonSound from "./../../assets/sounds/click-boton.mp3";

export type YelloCardProps = {
  title: string;
  body: string;
  author: string;
  display: boolean;
  continueLabel: string;
  timeOut: number;
};

type Props = {
  data: YelloCardProps;
  onTimeOut: () => void;
  isUsersTurn: boolean;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
}

export default function TellowCard(props: Props) {
  const { load } = useGlobalAudioPlayer();
  const { title, body, display, author, continueLabel } = props.data;
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    playButtonSound()
    props.onTimeOut();
    setOpen(false);
  };

  React.useEffect(() => {
    setOpen(props.data ? true : false);
  }, [props.data]);

  const playButtonSound = () => {
    load(ButtonSound, {
      autoplay: true,
    });
  };

  return (
    <Box>
      <BootstrapDialog
        className="titleDialogYellow dialogContainer"
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {title}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography className="quoteTextDialog" gutterBottom>
            {Parser().parse(sanitizeHtml(body))}
          </Typography>
          <Typography className="quoteTextDialog" gutterBottom>
            {author}
          </Typography>
          <CountdownTimer time={0.2} onTimeOut={props.onTimeOut} />
        </DialogContent>
        <DialogActions>
          {props.isUsersTurn && (
            <Button onClick={handleClose}>{continueLabel}</Button>
          )}
        </DialogActions>
      </BootstrapDialog>
    </Box>
  );
}
